module.exports = __webpack_public_path__ + "static/media/12.09358b40.png";